export const STATUS_OPTIONS = [
  { value: 'hold', label: 'Hold' },
  { value: 'confirm', label: 'Confirm' },
  { value: 'announced', label: 'Announced' },
  { value: 'artist_pre_sale', label: 'Artist Pre-Sale' },
  { value: 'pre_sale', label: 'Pre-Sale' },
  { value: 'on_sale', label: 'On Sale' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'postponed', label: 'Postponed' },
  { value: 'past', label: 'Past' },
];

export const buildStatusFilterGroup = () => ({
  id: 'event_details',
  label: 'Event Details',
  filters: [
    {
      id: 'calendar_classification',
      label: 'Status',
      type: 'checkbox',
      options: STATUS_OPTIONS,
    },
  ],
});

export const buildEventsFilterGroups = (venueOwnerships = []) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: venueOwnerships.map(vo => ({
          value: String(vo.id),
          label: vo.name,
        })),
      },
    ],
  },
  {
    id: 'event_details',
    label: 'Event Details',
    filters: [
      {
        id: 'calendar_classification',
        label: 'Status',
        type: 'checkbox',
        options: STATUS_OPTIONS,
      },
      {
        id: 'age_restriction',
        label: 'Age Restriction',
        type: 'checkbox',
        options: [
          { value: 'All Ages', label: 'All Ages' },
          { value: '13+', label: '13+' },
          { value: '16+', label: '16+' },
          { value: '17+', label: '17+' },
          { value: '18+', label: '18+' },
          { value: '19+', label: '19+' },
          { value: '21+', label: '21+' },
          { value: 'Under 18 must be accompanied by parent or guardian', label: 'Under 18 w/ Parent' },
        ],
      },
      {
        id: 'ticketing_arrangement',
        label: 'Ticketing',
        type: 'checkbox',
        options: [
          { value: 'Seated', label: 'Seated' },
          { value: 'General Admission', label: 'General Admission' },
        ],
      },
      {
        id: 'is_public',
        label: 'Public',
        type: 'checkbox',
        options: [
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ],
      },
    ],
  },
  {
    id: 'tickets',
    label: 'Tickets',
    filters: [
      {
        id: 'tickets_sold',
        label: 'Tickets Sold',
        type: 'range',
        options: [],
      },
      {
        id: 'tickets_scanned',
        label: 'Tickets Scanned',
        type: 'range',
        options: [],
      },
    ],
  },
  {
    id: 'dates',
    label: 'Dates',
    filters: [
      {
        id: 'date_range',
        label: 'Event Date Range',
        type: 'date_range',
        options: [],
      },
    ],
  },
];
